/**
 * SuggestionChips — 3 quick-action chips above the composer.
 * [Source: Story P1b spec §8]
 */
import { SUGGESTION_CHIPS } from '../welcome';
import { Button } from '../../../components/ui/Button';

interface Props {
  onPick: (label: string) => void;
  disabled?: boolean;
}

export function SuggestionChips({ onPick, disabled }: Props) {
  return (
    <div className="flex flex-wrap gap-2 pb-2">
      {SUGGESTION_CHIPS.map((chip) => (
        <Button
          key={chip.id}
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => onPick(chip.label)}
        >
          {chip.label}
        </Button>
      ))}
    </div>
  );
}
